import firebase from '../firebase';

const CreateUserInFirestore = async (user) => {
    const users = firebase.firestore().collection('users');
    await users.add(user);
};

export default CreateUserInFirestore;